export const ATTACH_CONFIRMATION_TIMEOUT_MS = 2000;

export enum Availability {
  Published = 'published',
  ViewOnly = 'view_only',
  Unapproved = 'unapproved',
}
